import React         from "react";

class PackageRender extends React.Component {

	render() {
		if(this.props.packages) {
			return (
				<div>{this.props.packages.length} available</div>
			);
		} else {
			return (
				<div>&nbsp;</div>
			);
		}
	}
}

// export the newly generated component
export default PackageRender;


/** WEBPACK FOOTER **
 ** ./src/modules/common/PackageRender.js
 **/